module.exports = __webpack_public_path__ + "static/media/21ECLAC3.2d932a30.jpg";